import React from 'react';

const clients = [
  { name: 'Rubus', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/ulkj928l_Rubus%20Logo.jpg' },
  { name: 'Swopper', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/ipo4e0r1_Swopper%20Logo.png' },
  { name: 'Insa Advokater', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/k3b3hy9p_Insa%20Advokater%20logo.jpg' },
  { name: 'Kirkens SOS', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/8a8ytznu_Kirkens%20SOS%20logo.jpg' },
  { name: 'Fishbuddy by Fiskher', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/fg3f65j9_Fishbuddy-by-fiskher_Liggende.png' },
  { name: 'Statskog', logo: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/n5ug4yym_Statskog_hovedlogo_rgb.png' },
  { name: 'Auctus Global', logo: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/0bflfkk3_Auctus%20Logo.jpeg' },
  { name: 'ICAN Nobel', logo: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/uzk74gxf_ICAN%20Nobel%20logo.svg' },
  { name: 'Skida', logo: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/dmpd42y4_LogoIndigo-%402x.png' },
  { name: 'NTL', logo: '/ntl-logo.png' }
];

const Clients = () => {
  return (
    <section id="clients" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            We have <span className="text-blue-600">worked with...</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center">
          {clients.map((client, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-6 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <img
                src={client.logo}
                alt={client.name}
                className="w-full h-auto max-h-16 object-contain opacity-60 group-hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;